





































































	import { Component, Vue } from 'vue-property-decorator'
	import HeadLable from '@/components/HeadLable/index.vue'
	import { queryAdminUserById, addAdminUser, editAdminUser } from '@/api/adminuser'  //把接口方法导入

	@Component({
		name: 'addShop',
		components: {
			HeadLable
		}
	})
	export default class extends Vue {
		private title = '添加员工'
		private actionType = ''
		private ruleForm = {
			name: '',
      phone: '',
			password: '',
			rePassword: '',
			idNumber: '',
			username: '',
      permissionLevel: 1
		}

		private validateRepassword (rule:any, value:any, callback:any) {
		  if (value === '') {
		    callback(new Error('请再次输入密码'))
		  } else if (value !== this.ruleForm.password) {
		    callback(new Error('两次输入密码不一致!'))
		  } else {
		    callback()
		  }
		}

		private isCellPhone(val : any) {
			if (!/^1(3|4|5|6|7|8)\d{9}$/.test(val)) {
				return false
			} else {
				return true
			}
		}

		private checkphone(rule : any, value : any, callback : any) {
			// let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
			if (value == '') {
				callback(new Error('请输入手机号'))
			} else if (!this.isCellPhone(value)) {
				//引入methods中封装的检查手机格式的方法
				callback(new Error('请输入正确的手机号!'))
			} else {
				callback()
			}
		}

		private validID(rule : any, value : any, callback : any) {
			// 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
			let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
			if (value == '') {
				callback(new Error('请输入身份证号码'))
			} else if (reg.test(value)) {
				callback()
			} else {
				callback(new Error('身份证号码不正确'))
			}
		}

		get rules() {
			return {
				name: [
					{
						required: true,
						// 'message': '请输入员工姓名',
						validator: (rule : any, value : string, callback : Function) => {
							if (!value) {
								callback(new Error('请输入员工姓名'))
							} else {
								// const reg = /^[\u4e00-\u9fa5_a-zA-Z]{1,12}$/
								// if (!reg.test(value)) {
								//   callback(new Error('姓名输入不符，请输入1-12个字符'))
								// } else {
								//   callback()
								// }
								callback()
							}
						},
						trigger: 'blur'
					}
				],
				username: [
					{
						required: true,
						// message: '请输入账号',
						validator: (rule : any, value : string, callback : Function) => {
							if (!value) {
								callback(new Error('请输入账号'))
							} else {
								const reg = /^([a-z]|[0-9]){3,20}$/
								if (!reg.test(value)) {
									callback(new Error('账号输入不符，请输入3-20个字符'))
								} else {
									callback()
								}
							}
						},
						trigger: 'blur'
					}
				],
				phone: [{ required: true, validator: this.checkphone, trigger: 'blur' }],
				idNumber: [{ required: true, validator: this.validID, trigger: 'blur' }],
				rePassword: [{ required: true, validator: this.validateRepassword, trigger: 'blur' }]

			}
		}

		created() {
			this.actionType = this.$route.query.id ? 'edit' : 'add'
			if (this.$route.query.id) {
				this.title = '修改员工信息'
				this.init()
			}
		}

		private async init() {
			const id = this.$route.query.id
			queryAdminUserById(id).then((res : any) => {
				// String(res.status) === '200'
				if (res.data.code === 1) {
					this.ruleForm = res.data.data
					this.ruleForm.password = ''
				} else {
					this.$message.error(res.data.msg)
				}
				// if (res.data.code == 200) {
				//   const { data } = res.data
				//   this.ruleForm = data
				//   this.ruleForm.password = ''
				//   // this.ruleForm.rePassword = '' //JSON.parse(JSON.stringify(data.password));
				// } else {
				//   this.$message.error(res.data.desc)
				// }
			})
		}

		private submitForm(formName : any, st : any) {
			; (this.$refs[formName] as any).validate((valid : any) => {
				if (valid) {
					if (this.actionType === 'add') {
						const params = {
							...this.ruleForm,
						}
						addAdminUser(params)
							.then((res : any) => {
								if (res.data.code === 1) {
									this.$message.success('员工添加成功！')
									if (!st) {
										this.$router.push({ path: '/adminuser' })
									} else {
										this.ruleForm = {
											username: '',
											name: '',
											phone: '',
											password: '',
											rePassword: '',
                      permissionLevel: 1,
											idNumber: ''
										}
									}
								} else {
									this.$message.error(res.data.msg)
								}
							})
							.catch(() => {
								// this.$message.error('请求出错了：' + err.message)
							})
					} else {
						const params = {
							...this.ruleForm,
						}
						editAdminUser(params)
							.then((res : any) => {
								if (res.data.code === 1) {
									this.$message.success('员工信息修改成功！')
									this.$router.push({ path: '/adminuser' })
								} else {
									this.$message.error(res.data.msg)
								}
							})
							.catch(() => {
								// this.$message.error('请求出错了：' + err.message)
							})
					}
				} else {
					return false
				}
			})
		}
	}
